import { render, staticRenderFns } from "./field-view.vue?vue&type=template&id=ec45fd98&"
import script from "./field-view.vue?vue&type=script&lang=js&"
export * from "./field-view.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports